import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/components/dashboard/hero-lab/HeroLab.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/components/headers/DashboardHeader.tsx");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/link.js");
